import React, { useEffect, useState } from "react";
import { Card, Flex, Switch } from "antd";
import { useThemeContext } from "../../../../context/ThemeContext";
import { storageService } from "../../../../services/storageService";
import "./index.scss";

const ExpertMode = () => {
  const { theme } = useThemeContext();
  const [enabledSwitch, setEnabledSwitch] = useState<
    "inBand" | "outBand" | null
  >(null);

  const handleSwitchChange = (type: "inBand" | "outBand") => {
    const newValue = enabledSwitch === type ? null : type;
    setEnabledSwitch(newValue);

    if (newValue) {
      storageService.setDtmfMode(newValue);
    } else {
      storageService.removeDtmfMode();
    }
  };

  useEffect(() => {
    const storedValue = storageService.getDtmfMode();
    if (storedValue === "inBand" || storedValue === "outBand") {
      setEnabledSwitch(storedValue);
    }
  }, []);

  return (
    <div className="expert-mode-container">
      <Card
        onClick={() => handleSwitchChange("inBand")}
        bordered={false}
        className="expert-mode-item-card"
        styles={{ body: { padding: "6px 12px" } }}
      >
        <Flex align="center" gap={10}>
          <div className="icon">
            <img src={`/assets/icons/${theme}/incoming-call.png`} alt="" />
          </div>
          <h6 className="card-title">Send In-of-band DTMF</h6>
          <div className="switch-wrapper custom-switch">
            <Switch
              size="small"
              checked={enabledSwitch === "inBand"}
              onChange={() => handleSwitchChange("inBand")}
            />
          </div>
        </Flex>
      </Card>

      <Card
        onClick={() => handleSwitchChange("outBand")}
        bordered={false}
        className="expert-mode-item-card"
        styles={{ body: { padding: "6px 12px" } }}
      >
        <Flex align="center" gap={10}>
          <div className="icon">
            <img src={`/assets/icons/${theme}/outgoing-call.png`} alt="" />
          </div>
          <h6 className="card-title">Send Out-of-band DTMF</h6>
          <div className="switch-wrapper custom-switch">
            <Switch
              size="small"
              checked={enabledSwitch === "outBand"}
              onChange={() => handleSwitchChange("outBand")}
            />
          </div>
        </Flex>
      </Card>
    </div>
  );
};

export default ExpertMode;
